import { Box, Text } from "@mantine/core";
import type { ReactNode } from "react";
import { axioTokens } from "../../theme";
import { ContentCard } from "../ui";

const VALUE_OFFSET = "var(--axio-unit-4)";

export const JOB_FACT_GRID_COLS = {
  base: 1,
  [axioTokens.containerQuery.sm]: 2,
  [axioTokens.containerQuery.lg]: 3,
} as const;

export function JobFactCard({
  label,
  children,
  tabular = false,
}: {
  label: string;
  children: ReactNode;
  tabular?: boolean;
}) {
  const isPlain = typeof children === "string" || typeof children === "number";
  return (
    <ContentCard>
      <Text size="xs" c="dimmed" fw="var(--axio-font-weight-semibold)">
        {label}
      </Text>
      <Box mt={VALUE_OFFSET} className={tabular ? "tabular" : undefined}>
        {isPlain ? (
          <Text fw="var(--axio-font-weight-semibold)">{children}</Text>
        ) : (
          children
        )}
      </Box>
    </ContentCard>
  );
}
